module.exports = __webpack_public_path__ + "static/media/inchang.2f558cba.png";